<template>
    <div class="declares_step3_form">
        <div class="header_content">
            <h3 class="title">指导老师</h3>
            <div class="header_add_btn">
                <Button type="primary" icon="md-add" @click="addPhysician">添加</Button>
            </div>
        </div>
        <div class="declares_step3_item" v-for="(item,index) in teacherList" :key="item.id">
            <div class="step3_item_index">{{index+1}}</div>
            <div class="step3_item_content">
                <div class="form_row">
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师姓名: </label>
                            <span>{{item.name}}</span>
                        </div>
                    </div>
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师单位: </label>
                            <span>{{item.company}}</span>
                        </div>
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师职称: </label>
                            <span>{{item.title}}</span>
                        </div>
                    </div>
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师工作年限: </label>
                            <span>{{item.work_year}}</span>
                        </div>
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师电话: </label>
                            <span>{{item.phone}}</span>
                        </div>
                    </div>
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师通讯地址: </label>
                            <span>{{item.address}}</span>
                        </div>
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师医师资格证书编码: </label>
                            <span>{{item.yszg_no}}</span>
                        </div>
                    </div>
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师通身份证号: </label>
                            <span>{{item.idcard_no}}</span>
                        </div>
                    </div>
                </div>
                <div class="form_row">
                    <div class="form_col">
                        <div class="form_col_txt">
                            <label>指导老师主要学习思想、临床经验和学术专长: </label>
                            <span>{{item.thought}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="step3_item_btn">
                <div>
                    <div class="step3_item_btnCon">
                        <Button type="primary" icon="ios-cloud-upload" style="width:100px" @click="uploadFile(item)">上传附件</Button>
                    </div>
                    <div class="step3_item_btnCon">
                        <Button type="primary" icon="ios-create-outline" style="width:100px" @click="editClick(item.id)">编辑</Button>
                    </div>
                    <div class="step3_item_btnCon">
                        <Button type="primary" icon="md-trash" style="width:100px" @click="deleteClick(item.id)">删除</Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="declares_step3_form_nolist" v-if="teacherList.length===0">暂无信息,请添加</div>
        <!--新增编辑-->
        <AddEdit :modalState="addExamineModal" :teacherid="teacherid" @change="addExamineUpdata" />
        <!--附件上传-->
        <UploadFile :modalState="UploadFileModal" :teacherNew="teacherNew" />
    </div>
</template>
<script>
import AddEdit from "./addEdit";
import UploadFile from "./uploadFile";
import { getTeacherList, DeleteTeacherNew } from "@/api/declare1/index";
import util from "@/libs/util";
export default {
    props:{
        selectType:{
            type: String,
            default() {
                return "";
            }
        }
    },
    components: {
        AddEdit,
        UploadFile
    },
    data() {
        return {
            addExamineModal: false,
            UploadFileModal:false,
            teacherNew:{},
            teacherList:[],
            teacherid:''
        }
    },
    mounted() {
        this.getTeacherLists();
    },
    methods: {
        // 获取老师信息列表
        getTeacherLists(){
            this.$emit("loadings",true);
            let userId = util.storage.getUserInfo().obj_id;
            let type = (this.selectType ==='sccs'? 1: 2);
            getTeacherList(userId,{identity_type:type}).then(res=>{
                this.teacherList = res;
                this.$emit("loadings",false);
            }).catch(() => {
              this.$emit("loadings",false);
            });
        },
        // 新增推荐医师
        addPhysician(){
            this.teacherid = "";
            this.addExamineModal= !this.addExamineModal;
        },
        // 推荐医师新增回调事件
        addExamineUpdata(){
            this.getTeacherLists();
        },
        // 上传附件
        uploadFile(item){
            this.teacherNew = item;
            this.UploadFileModal = !this.UploadFileModal;
        },
        // 编辑
        editClick(id){
            this.teacherid = id;
            this.addExamineModal= !this.addExamineModal;
        },
        // 删除
        deleteClick(id){
            this.$Modal.confirm({
                title: '提示',
                content: '<p>确认删除此条信息?</p>',
                onOk: () => {
                    this.$emit("loadings",true);
                    DeleteTeacherNew(id).then(()=>{
                        this.$emit("loadings",false);
                        this.getTeacherLists();
                    }).catch(() => {
                        this.$emit("loadings",false);
                    });
                }
            });
            
        }
    },
}
</script>